export class CommitterSealCompactionStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "binPack",
            "baseName": "binPack",
            "type": "CommitterCompactionStrategyStats",
            "format": ""
        },
        {
            "name": "sorted",
            "baseName": "sorted",
            "type": "CommitterCompactionStrategyStats",
            "format": ""
        },
        {
            "name": "emitted",
            "baseName": "emitted",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CommitterSealCompactionStats.attributeTypeMap;
    }
    constructor() {
    }
}
